import {
    DatePipe,
    HashLocationStrategy,
    LocationStrategy,
    PathLocationStrategy,
} from "@angular/common";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { DataTablesModule } from "angular-datatables";
import { NgxDaterangepickerMd } from "ngx-daterangepicker-material";
import { NgxWebstorageModule } from "ngx-webstorage";
import { AccordionModule } from "primeng/accordion";
import { AutoCompleteModule } from "primeng/autocomplete";
import { BreadcrumbModule } from "primeng/breadcrumb";
import { ButtonModule } from "primeng/button";
import { CalendarModule } from "primeng/calendar";
import { CardModule } from "primeng/card";
import { CarouselModule } from "primeng/carousel";
import { ChartModule } from "primeng/chart";
import { CheckboxModule } from "primeng/checkbox";
import { ChipsModule } from "primeng/chips";
import { CodeHighlighterModule } from "primeng/codehighlighter";
import { ColorPickerModule } from "primeng/colorpicker";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { ContextMenuModule } from "primeng/contextmenu";
import { DataViewModule } from "primeng/dataview";
import { DialogModule } from "primeng/dialog";
import { DropdownModule } from "primeng/dropdown";
import { EditorModule } from "primeng/editor";
import { FieldsetModule } from "primeng/fieldset";
import { FileUploadModule } from "primeng/fileupload";
import { FullCalendarModule } from "primeng/fullcalendar";
import { GalleriaModule } from "primeng/galleria";
import { GrowlModule } from "primeng/growl";
import { InplaceModule } from "primeng/inplace";
import { InputMaskModule } from "primeng/inputmask";
import { InputSwitchModule } from "primeng/inputswitch";
import { InputTextModule } from "primeng/inputtext";
import { InputTextareaModule } from "primeng/inputtextarea";
import { LightboxModule } from "primeng/lightbox";
import { ListboxModule } from "primeng/listbox";
import { MegaMenuModule } from "primeng/megamenu";
import { MenuModule } from "primeng/menu";
import { MenubarModule } from "primeng/menubar";
import { MessageModule } from "primeng/message";
import { MessagesModule } from "primeng/messages";
import { MultiSelectModule } from "primeng/multiselect";
import { OrderListModule } from "primeng/orderlist";
import { OrganizationChartModule } from "primeng/organizationchart";
import { OverlayPanelModule } from "primeng/overlaypanel";
import { PaginatorModule } from "primeng/paginator";
import { PanelModule } from "primeng/panel";
import { PanelMenuModule } from "primeng/panelmenu";
import { PasswordModule } from "primeng/password";
import { PickListModule } from "primeng/picklist";
import { ProgressBarModule } from "primeng/progressbar";
import { RadioButtonModule } from "primeng/radiobutton";
import { RatingModule } from "primeng/rating";
import { ScrollPanelModule } from "primeng/scrollpanel";
import { SelectButtonModule } from "primeng/selectbutton";
import { SidebarModule } from "primeng/sidebar";
import { SlideMenuModule } from "primeng/slidemenu";
import { SliderModule } from "primeng/slider";
import { SpinnerModule } from "primeng/spinner";
import { SplitButtonModule } from "primeng/splitbutton";
import { StepsModule } from "primeng/steps";
import { TableModule } from "primeng/table";
import { TabMenuModule } from "primeng/tabmenu";
import { TabViewModule } from "primeng/tabview";
import { TerminalModule } from "primeng/terminal";
import { TieredMenuModule } from "primeng/tieredmenu";
import { ToastModule } from "primeng/toast";
import { ToggleButtonModule } from "primeng/togglebutton";
import { ToolbarModule } from "primeng/toolbar";
import { TooltipModule } from "primeng/tooltip";
import { TreeModule } from "primeng/tree";
import { TreeTableModule } from "primeng/treetable";
import { VirtualScrollerModule } from "primeng/virtualscroller";
import { AddSchedulerComponent } from "./add-scheduler/add-scheduler.component";
import { AppBreadcrumbComponent } from "./app.breadcrumb.component";
import { AppComponent } from "./app.component";
import { AppFooterComponent } from "./app.footer.component";
import { AppMenuComponent, AppSubMenuComponent } from "./app.menu.component";
import { AppProfileComponent } from "./app.profile.component";
import { AppRoutes } from "./app.routes";
import { AppTopBarComponent } from "./app.topbar.component";
import { ArchivePurgeComponent } from "./archive-purge/archive-purge.component";
import { BreadcrumbService } from "./breadcrumb.service";
import { CorrelationsComponent } from "./correlations/correlations.component";
import { DailyStatusViewComponent } from "./daily-status-view/daily-status-view.component";
import { HttpInterceptorInterceptor } from "./http-interceptor.interceptor";
import { LoginComponent } from "./login/login.component";
import { MDashboardComponent } from "./m-dashboard/m-dashboard.component";
import { MDocRepositoryComponent } from "./m-doc-repository/m-doc-repository.component";
import { MShipmentComponent } from "./m-shipment/m-shipment.component";
import { MyserviceService } from "./myservice.service";
import { PartnerComponent } from "./partner/partner.component";
import { ProfileComponent } from "./profile/profile.component";
import { SchedulerComponent } from "./scheduler/scheduler.component";
import { StatusComponent } from "./status/status.component";
import { TransactiongroupComponent } from "./transactiongroup/transactiongroup.component";
import { UserCreationComponent } from "./user-creation/user-creation.component";
import { UserSearchComponent } from "./user-search/user-search.component";
import { WarehouseLifecycleComponent } from "./warehouse-lifecycle/warehouse-lifecycle.component";
import { WarehouseOrderManagementComponent } from "./warehouse-order-management/warehouse-order-management.component";
import { WarehouseVolumesComponent } from "./warehouse-volumes/warehouse-volumes.component";
import { SendFilesComponent } from './send-files/send-files.component';
import { SfgDocRepoComponent } from './sfg-doc-repo/sfg-doc-repo.component';
import { SfgArchivePurgeComponent } from './sfg-archive-purge/sfg-archive-purge.component';
import { SfgPartnersComponent } from './sfg-partners/sfg-partners.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { UnAuthPageComponent } from './un-auth-page/un-auth-page.component';
import { MultipleFileDownloadComponent } from './multiple-file-download/multiple-file-download.component';
import { MessageService } from "primeng/api";
import { ConfigComponent } from "./config/config.component";
import { NgxCaptchaModule } from "ngx-captcha";
import { RegisterComponent } from "./registeration/register/register.component";
import { TradingPartnerComponent } from "./trading-partner/trading-partner.component";
import { TradingPartnerSetupComponent } from "./trading-partner-setup/trading-partner-setup.component";
import { DocumentStatsComponent } from "./document-stats/document-stats.component";
import { OAuthModule } from 'angular-oauth2-oidc';
import { TradingPartnerDetailsComponent } from './trading-partner-details/trading-partner-details.component';
import { ErrorHandlingReportsComponent } from './error-handling-reports/error-handling-reports.component';
import { ErrorHandlingDetailsComponent } from './error-handling-details/error-handling-details.component';
import { DownloadsComponent } from './downloads/downloads.component';
@NgModule({
    imports: [
        BrowserModule,
        FormsModule,
        AppRoutes,
        OAuthModule.forRoot(),
        HttpClientModule,
        BrowserAnimationsModule,
        AccordionModule,
        AutoCompleteModule,
        BreadcrumbModule,
        ButtonModule,
        CalendarModule,
        CardModule,
        CarouselModule,
        SidebarModule,
        ChartModule,
        CheckboxModule,
        ChipsModule,
        CodeHighlighterModule,
        ConfirmDialogModule,
        ColorPickerModule,
        ContextMenuModule,
        DataViewModule,
        DialogModule,
        DropdownModule,
        EditorModule,
        FieldsetModule,
        FileUploadModule,
        FullCalendarModule,
        GalleriaModule,
        GrowlModule,
        InplaceModule,
        InputMaskModule,
        InputSwitchModule,
        InputTextModule,
        InputTextareaModule,
        LightboxModule,
        ListboxModule,
        MegaMenuModule,
        MenuModule,
        MenubarModule,
        MessageModule,
        MessagesModule,
        MultiSelectModule,
        OrderListModule,
        OrganizationChartModule,
        OverlayPanelModule,
        PaginatorModule,
        PanelModule,
        PanelMenuModule,
        PasswordModule,
        PickListModule,
        ProgressBarModule,
        RadioButtonModule,
        RatingModule,
        ScrollPanelModule,
        SelectButtonModule,
        SlideMenuModule,
        SliderModule,
        SpinnerModule,
        SplitButtonModule,
        StepsModule,
        TableModule,
        TabMenuModule,
        TabViewModule,
        TerminalModule,
        TieredMenuModule,
        ToastModule,
        ToggleButtonModule,
        ToolbarModule,
        TooltipModule,
        TreeModule,
        TreeTableModule,
        VirtualScrollerModule,
        DataTablesModule,
        NgxDaterangepickerMd,
        NgxWebstorageModule.forRoot(),
        ReactiveFormsModule,
        PdfViewerModule,
        NgxCaptchaModule,
    ],
    declarations: [
        AppComponent,
        AppMenuComponent,
        AppSubMenuComponent,
        AppProfileComponent,
        AppBreadcrumbComponent,
        AppTopBarComponent,
        AppFooterComponent,
        LoginComponent,
        RegisterComponent,
        ConfigComponent,
        TradingPartnerComponent,
        TradingPartnerSetupComponent,
        DocumentStatsComponent,
        DailyStatusViewComponent,
        ProfileComponent,
        UserSearchComponent,
        UserCreationComponent,
        PartnerComponent,
        SchedulerComponent,
        AddSchedulerComponent,
        MShipmentComponent,
        MDocRepositoryComponent,
        MDashboardComponent,
        CorrelationsComponent,
        ArchivePurgeComponent,
        WarehouseVolumesComponent,
        WarehouseOrderManagementComponent,
        WarehouseLifecycleComponent,
        StatusComponent,
        TransactiongroupComponent,
        SendFilesComponent,
        SfgDocRepoComponent,
        SfgArchivePurgeComponent,
        SfgPartnersComponent,
        UnAuthPageComponent,
        MultipleFileDownloadComponent,
        TradingPartnerDetailsComponent,
        ErrorHandlingReportsComponent,
        ErrorHandlingDetailsComponent,
        DownloadsComponent,
    ],
    providers: [
        {provide: HTTP_INTERCEPTORS,  useClass: HttpInterceptorInterceptor, multi: true},
        // { provide: LocationStrategy, useClass: HashLocationStrategy },
        { provide: LocationStrategy, useClass: PathLocationStrategy },
        BreadcrumbService,
        MyserviceService,
        DatePipe,
        MessageService
    ],
    bootstrap: [AppComponent],
})
export class AppModule {}
